// extracted by mini-css-extract-plugin
module.exports = {"Odometer":"Odometer_Odometer__DXWO2","Digit":"Odometer_Digit__Zo_fn"};